import React from "react";
import classes from './Footer.module.scss';
import { useAppContent } from "../../../shared/AppContent";

const Footer = ({ className }) => {
    const { footerContainer } = useAppContent();
    return (
        <div className={`${classes.footer_container} ${className}`}>
            <div className={classes.footer_innercontainer}>
                <div className={classes.footer_left}>
                    {/* <span>© SBI Card 2022</span> */}
                    <span> {footerContainer?.copyrightLabel}</span>
                </div>
                <div className={classes.footer_right}>
                    <a className={classes.footer_link} target="_blank" rel="noopener noreferrer" href={footerContainer?.tnc_container?.URL}><span>{footerContainer?.tnc_container?.label} </span></a>
                    <a className={classes.footer_link} target="_blank" rel="noopener noreferrer" href={footerContainer?.cardHolder_container?.URL}><span>{footerContainer?.cardHolder_container?.label} </span></a>
                    <a className={classes.footer_link} target="_blank" rel="noopener noreferrer"  href={footerContainer?.privacy_container?.URL}><span className={classes.last_child}>{footerContainer?.privacy_container?.label}</span></a>
                </div>
            </div>

        </div>
    )
}

export default Footer;